import AdminDashboardClient from "@/components/admin/AdminDashboardClient";
import { LayoutDashboard } from "lucide-react";

export default function AdminDashboardPage() {
    return (
        <div className="space-y-8">
            <div className="sticky top-0 z-20 -mx-4 border-b border-slate-200 bg-white px-4 py-3 shadow-sm sm:-mx-6 sm:px-6 md:-mx-8 md:px-8">
                <div className="flex items-center gap-3">
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600">
                        <LayoutDashboard className="h-4 w-4" />
                    </div>
                    <h1 className="text-xl md:text-2xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-slate-900 to-slate-600">
                        Dashboard
                    </h1>
                </div>
                <p className="mt-1 text-sm text-slate-500 font-medium leading-tight">
                    Overview of your organization&apos;s courses and progress.
                </p>
            </div>
            <AdminDashboardClient />
        </div>
    );
}
